type ExtractParams<S extends string> = string extends S
  ? Record<string, string>
  : S extends `${infer Start}{${infer Param}}${infer Rest}`
    ? { [K in Param | keyof ExtractParams<Rest>]: string }
    : {};

export function replaceParams<T extends string>(template: T, params: ExtractParams<T>): string {
  const keys = Object.keys(params) as Array<keyof ExtractParams<T>> as string[];
  return keys.reduce(
    (acc, key) => acc.replace(new RegExp(`{${key}}`, "g"), (params as any)[key]),
    template,
  );
}
